import { DispatchAction } from "@iolabs/redux-utils";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import React, { useRef, useState } from "react";
import Icon from "../../../Icon/Icon";
import EquipmentDialog from "../EquipmentDialog/EquipmentDialog";
import useStyles from "./styles";
import ExporterImporter from "../../../ExporterImporter/ExporterImporter";
import { exportMaterial, importMaterial } from "../../../../packages/Api/data/material/client";
import { onEquipmentCatalogue, onMaterialCatalogue } from "../../../../redux/mapping";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import messages from "./messages";
import { useKeycloak } from "@react-keycloak/web";
import { exportEquipment, importEquipment } from "../../../../packages/Api/data/equipment/client";

interface IEquipmentDialogWrapperProps {}

const EquipmentDialogWrapper: React.FC<IEquipmentDialogWrapperProps> = () => {
    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { keycloak } = useKeycloak();
    const dispatch = useDispatch<DispatchAction>();

    const [open, setOpen] = useState<boolean>(false);
    const [selectedEquipmentIds, setSelectedEquipmentIds] = useState<number[]>([]);
    const [addModeActive, setAddModeActive] = useState<boolean>(false);

    const equipmentDialogRef = useRef();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSelectedEquipmentIds = (rowIDs: number[]) => {
        setSelectedEquipmentIds(rowIDs);
    };

    const handleAddModeActive = (active: boolean) => {
        setAddModeActive(active);
    };

    // translations
    const intl = useIntl();
    const transExport = intl.formatMessage({ ...messages.export });
    const transImport = intl.formatMessage({ ...messages.import });
    const transEquipmentCatalogue = intl.formatMessage({ ...messages.equipmentCatalogue });
    const transCreateNewEquipment = intl.formatMessage({ ...messages.createNewEquipment });
    const transEquipment = intl.formatMessage({ ...messages.equipment });
    const transDevice = intl.formatMessage({ ...messages.device });
    const transAddToPosition = intl.formatMessage({ ...messages.addToPosition });

    return (
        <>
            <IconButton
                aria-label="add"
                color="primary"
                className={clsx("globalAddButton", classes.addButton)}
                onClick={handleOpen}
            >
                <Icon name="plus" size={20} />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="equipment-position-dialog-title"
                aria-describedby="equipment-position-dialog-description"
                maxWidth={false}
                fullWidth
                fullScreen={fullScreen}
                className={classes.root}
                scroll="paper"
            >
                <DialogTitle id="equipment-position-dialog-title">
                    {transEquipmentCatalogue}
                </DialogTitle>
                <DialogContent classes={{ root: classes.dialogContentRoot }}>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <EquipmentDialog
                        ref={equipmentDialogRef}
                        addModeActive={addModeActive}
                        selectedEquipmentIds={selectedEquipmentIds}
                        handleAddModeActive={handleAddModeActive}
                        handleSelectedEquipmentIds={handleSelectedEquipmentIds}
                        handleClose={handleClose}
                    />
                </DialogContent>
                <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                    {/*<NullableTooltip title="Create new equipment" placement="top">*/}
                    {/*    <IconButton*/}
                    {/*        aria-label="add"*/}
                    {/*        color="primary"*/}
                    {/*        className={clsx("globalAddButton", classes.addButton)}*/}
                    {/*        onClick={() => {*/}
                    {/*            // @ts-ignore*/}
                    {/*            equipmentDialogRef?.current?.handlePrepareAddEquipment();*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <Icon name="plus" size={20} />*/}
                    {/*    </IconButton>*/}
                    {/*</NullableTooltip>*/}
                    <Button
                        variant="outlined"
                        color="default"
                        size="medium"
                        onClick={() => {
                            // @ts-ignore
                            equipmentDialogRef?.current?.handlePrepareAddEquipment();
                        }}
                    >
                        {transCreateNewEquipment}
                    </Button>
                    <Box className={classes.exportImport}>
                        <ExporterImporter
                            fileName={"Equipment.xlsx"}
                            exportLabel={transExport}
                            importLabel={transImport}
                            exportCallback={(token, data) => {
                                exportEquipment(token);
                            }}
                            importCallback={importEquipment}
                            onImportDoneCallback={(response) => {
                                dispatch(onEquipmentCatalogue({ token: keycloak?.token as string }))
                            }}
                        />
                    </Box>
                    <Button
                        type="submit"
                        variant="contained"
                        color="secondary"
                        size="medium"
                        disabled={selectedEquipmentIds?.length === 0 || addModeActive}
                        onClick={() => {
                            // @ts-ignore
                            equipmentDialogRef?.current?.handleAddEquipmentToPosition();
                            handleClose();
                        }}
                    >
                        {selectedEquipmentIds?.length > 1 ? transEquipment : transDevice} {transAddToPosition}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EquipmentDialogWrapper;
